//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
export const ui = (state = {}, action) => {
    switch (action.type) {
        case "UI": {
            return {
                menu: action.payload.menu,
                articles: action.payload.articles,
                about_video: action.payload.about_video,
                courses: action.payload.courses,
                category_parent: action.payload.categories,
                quick_news: action.payload.slider_text,
                sliders: action.payload.sliders,
                achievements: action.payload.achievements,
                sections: action.payload.banner_images,
                background: action.payload.background,
                work_samples: action.payload.work_samples,
                story: action.payload.story,
                courses_with_offer: action.payload.courses_with_offer,
                faqs: action.payload.faqs,
                top_students : action.payload.top_students,
                vip_courses : action.payload.vip_courses,
                statistics : action.payload.statistics,
                settings : action.payload.settings,
            }
        }
        default: {
            return state
        }
    }
}
